<mat-card class="slidecontent">
  <div class="headcontent">
    <div class="pophead">
      <h3>Update Field</h3>

      <mat-icon class="close" (click)="closeEdit(closeEditPopup)">close</mat-icon>
    </div>

  </div>
  <div class="dialog_content">

    <form class="fix-mat-form-field" [formGroup]="updateCustomfieldForm">
      <div  class="lblcus">
        <label>Select Category</label>
        
        <mat-radio-group *ngIf="updateFieldmodel.fieldCategotyTypeID!='1'"  aria-label="Select an option" [(ngModel)]="updateFieldmodel.fieldCategotyTypeID" color="primary" formControlName="fieldCategoty"
          (change)="onRadiobuttonChange($event)">
          <mat-radio-button value="2" [disabled]="glbalDisable">Global </mat-radio-button>
          <mat-radio-button value="3" [disabled] = "customDisable">Custom</mat-radio-button>
        </mat-radio-group>
        <mat-radio-group *ngIf="updateFieldmodel.fieldCategotyTypeID=='1'"  aria-label="Select an option" [(ngModel)]="updateFieldmodel.fieldCategotyTypeID" color="primary" formControlName="fieldCategoty"
          (change)="onRadiobuttonChange($event)">
          <mat-radio-button value="1" [disabled]="true">Default</mat-radio-button>  
        </mat-radio-group>
      </div>



      <mat-form-field class="example-full-width flName "  appearance="outline">
        <mat-label>Add Label</mat-label>
        
        <input matInput formControlName="fieldName" *ngIf="updateFieldmodel.fieldCategotyTypeID!='1'" [(ngModel)]="updateFieldmodel.fieldName" placeholder="Field Name" #fieldName value=""  /> 
        <input matInput formControlName="fieldName" *ngIf="updateFieldmodel.fieldCategotyTypeID=='1'" [(ngModel)]="updateFieldmodel.fieldName" disabled="true" placeholder="Field Name" #fieldName value=""  readonly/>
        <mat-select name="ampm"  (selectionChange)="globalPermission($event)" class="ampm" [(value)]="selectedGlobalPermission" [disabled]="updateFieldmodel.fieldCategotyTypeID=='1'">
          <mat-option value="0">Editable</mat-option>
          <mat-option value="1">Read Only</mat-option>
          <mat-option value="2">Hidden</mat-option>
        </mat-select>
      </mat-form-field>

      <div class="advanced">
        <button mat-button type="button" (click)="addpermission()" color="primary" [disabled]="updateFieldmodel.fieldCategotyTypeID=='1'">
          <span *ngIf="!givePermission" >Add Permission</span>
          <span *ngIf="givePermission" >Cancel</span>
        </button>
      </div>

      <div class="forRead" *ngIf="givePermission">
        <mat-form-field  class="" appearance="fill">
          <mat-label>Search role to give permission</mat-label>
            <input matInput
                   placeholder="Search"
                   aria-label="Search Role"
                   [matAutocomplete]="auto" 
                   (input)="searchRole($event.target.value)"
                   id="RoleCtrlID"
                   [formControl]="roleCtrlFormControl">
            <mat-autocomplete #auto="matAutocomplete">
              <mat-option (click)="roleSelected(obj)"   *ngFor="let obj of roleListFiltered" [value]="obj.roleName">
                <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
                    <div class="info">
                      <p> {{ obj.roleName }}</p>
                    </div> 
                </span>
              </mat-option>
            </mat-autocomplete>
        </mat-form-field>

        <ul class="selectedlist">
          <ng-container *ngFor="let sr of selectedRoleList">
          <li *ngIf="sr.isDeleted==false">

            <div class="userndetail">
              <button class="removeRole" mat-icon-button (click)="deletePermission(sr)" ><mat-icon>remove_circle_outline</mat-icon></button>
              {{sr.name}}
            </div>
            <div class="option">
              
              <button *ngIf='sr.permission==0' mat-button [matMenuTriggerFor]="menu"><mat-icon>edit_off</mat-icon> Editable</button>
              
              <button *ngIf='sr.permission==1' mat-button [matMenuTriggerFor]="menu"><mat-icon>local_library</mat-icon> Read Only</button>
              
              <button *ngIf='sr.permission==2' mat-button [matMenuTriggerFor]="menu"><mat-icon>visibility_off</mat-icon> Hidden</button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="changePermission(sr,0)" *ngIf='sr.permission!==0'><mat-icon>edit_off</mat-icon>  Editable</button>
                <button mat-menu-item (click)="changePermission(sr,1)" *ngIf='sr.permission!==1'><mat-icon>local_library</mat-icon>  Read Only</button>
                <button mat-menu-item (click)="changePermission(sr,2)" *ngIf='sr.permission!==2'><mat-icon>visibility_off</mat-icon> Hidden</button>
              </mat-menu>
            </div>
           
              
          </li>
        </ng-container>
        </ul>

      </div>
      

      <mat-form-field>
        <mat-select placeholder="Select Field Type" (selectionChange)="displayFieldOnFieldTypeSelection($event)"
          [(ngModel)]="updateFieldmodel.fieldTypeID" name="typeSelected" formControlName="fieldTypeID"
          [disabled]="updateFieldmodel.fieldCategotyTypeID=='1'" >

          <mat-option *ngFor="let fieldType of fieldTypeList" [value]="fieldType.fieldTypeID">

            <!-- <mat-icon matSuffix *ngIf="fieldType.fieldTypeName == 'Image'">add_a_photo</mat-icon>
              <mat-icon matSuffix *ngIf="fieldType.fieldTypeName == 'URL'">link</mat-icon> 
              <mat-icon matSuffix *ngIf="fieldType.fieldTypeName == 'Text area'">subject</mat-icon> 
              <mat-icon matSuffix *ngIf="fieldType.fieldTypeName == 'Number'">looks_one</mat-icon> 
              <mat-icon matSuffix *ngIf="fieldType.fieldTypeName == 'Multiselect dropdown'">format_list_bulleted</mat-icon> 
              <mat-icon matSuffix *ngIf="fieldType.fieldTypeName == 'Date'">insert_invitation</mat-icon> 
              <mat-icon matSuffix *ngIf="fieldType.fieldTypeName == 'Currency'">monetization_on</mat-icon> 
              <mat-icon matSuffix *ngIf="fieldType.fieldTypeName == 'CheckBox'">check_box</mat-icon> 
              <mat-icon matSuffix *ngIf="fieldType.fieldTypeName == 'DropDown'">arrow_drop_down_circle</mat-icon> 
              <mat-icon matSuffix *ngIf="fieldType.fieldTypeName == 'Text Box'">short_text</mat-icon>  -->
           
              {{fieldType.fieldTypeName}}

          </mat-option>
        </mat-select>
      </mat-form-field>

      <div class="custom" *ngIf="showTextBoxField">
        <label>Input Type</label>
        <div class="row" *ngFor="let row of inputTypeFieldArray; let i = index">
          <div class="getvalue">

            <mat-form-field class="example-full-width">
              <input [(ngModel)]="row.fieldText" [ngModelOptions]="{standalone: true}" matInput
                placeholder="Add default value" [disabled]="updateFieldmodel.fieldCategotyTypeID=='1'" (ngModelChange)="valuechange($event)"/>
            </mat-form-field>

            <mat-form-field class="example-full-width">
              <input [(ngModel)]="row.placeholder" formControlName="textboxPlaceholder"  matInput
                placeholder="Add placeholder name" value="" />
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="custom" *ngIf="showImageField">
        <label>Input Type</label>
        <div class="row" *ngFor="let row of imageTypeFieldArray; let i = index">
          <div class="getvalue">
            <mat-form-field class="example-full-width">
              <input [(ngModel)]="row.altText" [ngModelOptions]="{standalone: true}" matInput placeholder="Add alt text"
                value="" />
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="custom" *ngIf="showDateField">
        <label>Input placeholder</label>
        <div class="row" *ngFor="let row of dateTypeFieldArray; let i = index">
          <div class="getvalue">
            <mat-form-field class="example-full-width">
              <input [(ngModel)]="row.dateKey" formControlName="datePlaceholder" matInput
                placeholder="Add placeholder name" value=""/>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="custom" *ngIf="showUrlField">
        <label>Input placeholder</label>
        <div class="row" *ngFor="let row of urlTypeFieldArray; let i = index">
          <div class="getvalue">
            <mat-form-field class="example-full-width">
              <input [(ngModel)]="row.url" formControlName="urlPlaceholder" matInput placeholder="Add placeholder name"
                value="" />
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="custom" *ngIf="showNumberField">
        <label>Input placeholder</label>
        <div class="row" *ngFor="let row of numberTypeFieldArray; let i = index">
          <div class="getvalue">
            <mat-form-field class="example-full-width">
              <input type="text" [(ngModel)]="row.number" formControlName="numberPlaceholder" matInput
                placeholder="Add placeholder name"/>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="custom" *ngIf="showCurrencyField">
        <label>Input placeholder</label>
        <div class="row" *ngFor="let row of numberTypeFieldArray; let i = index">
          <div class="getvalue">
            <mat-form-field class="example-full-width">
              <input type="text" [(ngModel)]="row.number" formControlName="currencyPlaceholder" matInput
                placeholder="Add placeholder name"/>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="custom" *ngIf="showRadioField">
        <label>Radio Type</label>
        <div class="row" *ngFor="let row of radioFieldArray; let i = index">
         
          <div class="getvalue">
            <div appearance="legacy" fxFlex>
             
              <mat-form-field class="example-full-width">
                <mat-label>Option 1</mat-label>
                <input matInput placeholder="Add Option 1" (ngModelChange)="valuechange($event)" [(ngModel)]="row.radioText"
                  [ngModelOptions]="{standalone: true}" />
              </mat-form-field>
            </div>
          </div>
          <div class="remove" *ngIf="i > 0">
            <button mat-icon-button (click)="deleteField('r',i)">
              <mat-icon>remove_circle_outline</mat-icon>
            </button>
          </div>
        </div>

        <button mat-mini-fab color="primary" (click)="addValueFieldRadio()" class="add">
          <mat-icon>add</mat-icon>
        </button>

      </div>

      <div class="custom" *ngIf="showCheckboxField">
        <label>Checkbox Type</label>
        <div class="row" *ngFor="let row of checkBoxFieldArray; let i = index">
          <div class="symbol">
            <mat-icon>check_box_outline_blank</mat-icon>
          </div>
          <div class="getvalue">
            <div appearance="legacy" fxFlex>             

              <mat-form-field class="example-full-width">
                <mat-label>Option {{i+1}}</mat-label>
                <input matInput placeholder="Add Option {{i+1}}" (ngModelChange)="valuechange($event)" [(ngModel)]="row.Select"
                  [ngModelOptions]="{standalone: true}" />
              </mat-form-field>
            </div>
          </div>
          <div class="remove" *ngIf="i > 0">
            <button mat-icon-button (click)="deleteField('c',i)">
              <mat-icon>remove_circle_outline</mat-icon>
            </button>
          </div>
        </div>

        <button mat-mini-fab color="primary" (click)="addValueField()" class="add">
          <mat-icon>add</mat-icon>
        </button>

      </div>

      <div class="custom" *ngIf="showDropdownBoxField">
        <mat-form-field>
        <mat-label>Add Placeholder Name</mat-label>
        <input matInput [(ngModel)]="dropDownPlace" formControlName="dropPlaceholder"  placeholder="Add Placeholder name"
          value="" />
          </mat-form-field>
        <label>Dropdown Type</label>
        <div class="row">
          <div class="getvalue">            
            <div *ngFor="let row of dropdownFieldArray; let i = index" fxLayout="row" fxLayoutAlign="center center">
              <mat-form-field class="example-full-width">
                <mat-label>Option {{i+1}}</mat-label>
                <input matInput placeholder="Add Option {{i+1}}" (ngModelChange)="valuechange($event)" [(ngModel)]="row.dropdownText"
                  [ngModelOptions]="{standalone: true}" />
              </mat-form-field>


              <div class="remove" *ngIf="i > 0">
                <button mat-icon-button (click)="deleteField('d',i)">
                  <mat-icon>remove_circle_outline</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>

        <button mat-mini-fab color="primary" (click)="addValueFieldropdown()" class="add">
          <mat-icon>add</mat-icon>
        </button>

      </div>     
        
      <div class="folList" *ngIf="showFieldVategoryTypeGlobal">

        <label>Add this field to other tabs</label>

        <div class="allfollist">
          <ng-container *ngFor="let data of fieldsList; let i=index">
            <div class="fol">
              <mat-checkbox color="primary" [value]="data.folderID" [checked]="folderIdCheckbox.includes(data.folderID)" (change)="onCheckboxChange($event)"
              [disabled]="updateFieldmodel.fieldCategotyTypeID=='1'">
                {{data.folderName}}</mat-checkbox>
            </div>

          </ng-container>
        </div>

      </div>

      <!-- (selectionChange)="displayCoreTypeSelection($event)" -->

      <div class="custom mt-10 " >
        <mat-form-field class="mt-10" >
        <mat-select required="true" placeholder='Available On' [(ngModel)]="updateFieldmodel.availableonForms" 
        formControlName="availableonForms"  (selectionChange)="displayavailableonSelection($event)"
        [disabled]="updateFieldmodel.fieldCategotyTypeID=='1'">
          <mat-option   [value]= '1'>
            Selected Tabs only
         </mat-option>
         <mat-option   [value]= '2'>
          Forms Only
         </mat-option>
         <mat-option   [value] = '3'>
          Both (Tabs and Forms)
         </mat-option>
        </mat-select>       
      </mat-form-field>
    </div>
      
      <div class="custom" *ngIf="showFieldVategoryTypecustom">
        <div fxLayout="row" fxLayoutAlign="start start">
          <mat-form-field>
            <mat-select multiple placeholder="{{CoreName}}" name="coreSelected"
              (selectionChange)="displayCoreTypeSelection($event)" [(ngModel)]="corevaluesDropdown" [ngModelOptions]="{standalone: true}" >
              <mat-option *ngFor="let core of coreList" [value]="core.subFolderID">
                {{core.folderName}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutAlign="start start">
          <mat-form-field>
            <mat-select multiple placeholder="{{ContactName}}" name="contactSelected"
              (selectionChange)="displayContactTypeSelection($event)" [(ngModel)]="contactvaluesDropdown" [ngModelOptions]="{standalone: true}">
              <mat-option *ngFor="let contact of contactList" [value]="contact.subFolderID">
                {{contact.folderName}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- <div fxLayout="row" fxLayoutAlign="start start">
          <mat-form-field>
            <mat-select multiple placeholder="Task" name="TaskSelected"
              (selectionChange)="displayTaskTypeSelection($event)" [(ngModel)]="taskvaluesDropdown" [ngModelOptions]="{standalone: true}">
              <mat-option *ngFor="let task of taskList" [value]="task.subFolderID">
                {{task.folderName}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div> -->

        <div fxLayout="row" fxLayoutAlign="start start">
          <mat-form-field>
            <mat-select multiple placeholder="{{CompanyName}}" name="companySelected"
              (selectionChange)="displayCompanyTypeSelection($event)" [(ngModel)]="companyvaluesDropdown" [ngModelOptions]="{standalone: true}">
              <mat-option *ngFor="let company of companyList" [value]="company.subFolderID">
                {{company.folderName}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>



      
      </div>

    </form>
  </div>

  <div class="actionBtn">
    <button mat-flat-button class="cancel" (click)="closeEdit(closeEditPopup)">
      Cancel
    </button>
    <button mat-flat-button class="calltoaction"  [disabled]="!updateCustomfieldForm.valid || folderIdCheck != true || !this.updateCustomfieldForm.dirty"
     (click)="updateField(updateCustomfieldForm.value)" type="submit" color="primary">
      Update
      <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
      </mat-spinner></mat-icon>
    </button>
  </div>

</mat-card>


<div class="overlay" (click)="closeEdit(closeEditPopup)"></div>
